import * as j from '@mojotech/json-type-validation';

export const PaymentDetailsDecoder: j.Decoder<Record<string, string>> = j.dict(j.string());
